import { classNames, formatCurrency } from "helpers";
import { PnlRowProps, PnlTableProps } from "./types";

// Sve je text-sm kao i zaglavlje kartice; hijerarhiju nose debljina i uvlaka, ne veličina.
const PnlRow: React.FC<PnlRowProps> = ({ label, amount, isGroup, isNegative }) => (
  <div
    className={classNames(
      "flex justify-between px-4 py-2 text-sm",
      isGroup ? "font-semibold text-slate-800" : "pl-8 text-slate-600"
    )}
  >
    <span>{label}</span>
    <span className={isNegative ? "text-rose-600" : ""}>
      {isNegative ? "−" : ""}
      {formatCurrency.format(Math.abs(amount))}
    </span>
  </div>
);

// `h-full` uz `flex flex-col`: kartica se rastegne na visinu grafa uz sebe, a redak
// sa zaradom `mt-auto` odgurne na dno umjesto da ostane prazan prostor ispod njega.
const PnlTable: React.FC<PnlTableProps> = ({ totals }) => (
  <div className="bg-white rounded-sm border h-full flex flex-col">
    <div className="px-4 py-3 border-b border-slate-200 text-sm font-semibold text-slate-800">
      Račun dobiti i gubitka
    </div>
    <PnlRow label="Prihodi" amount={totals.revenue} isGroup />
    <PnlRow label="Prodaja vozila" amount={totals.saleRevenue} />
    <PnlRow label="Najam" amount={totals.rentRevenue} />
    <PnlRow label="Rashodi" amount={totals.expense} isGroup isNegative />
    <PnlRow label="Nabava vozila" amount={totals.vehiclePurchase} isNegative />
    <PnlRow label="Troškovi vozila" amount={totals.vehicleCost} isNegative />
    <PnlRow label="Opći troškovi (bez vozila)" amount={totals.generalCost} isNegative />
    <div className="mt-auto flex justify-between px-4 py-3 border-t border-slate-200 text-sm font-bold">
      <span>Zarada</span>
      <span className={totals.profit >= 0 ? "text-emerald-700" : "text-rose-600"}>
        {formatCurrency.format(totals.profit)}
      </span>
    </div>
  </div>
);

export default PnlTable;
